"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const PowerSettingsNew_1 = __importDefault(require("@mui/icons-material/PowerSettingsNew"));
const Settings_1 = __importDefault(require("@mui/icons-material/Settings"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const initials_1 = __importDefault(require("initials"));
const lodash_1 = __importDefault(require("lodash"));
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const Settings_2 = __importDefault(require("../../../../hsbc_img/img/Settings"));
const sessionQuery_1 = require("../../../../queries/sessionQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const zustandStore_1 = require("../../../../zustandStore");
require("./style.less");
const logger = (0, pino_1.default)();
const SideMenuFooter = ({ openUserDetailsAside = () => ({}) } = {}) => {
    const { data: user } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const logout = (0, sessionQuery_1.useSessionLogoutQuery)();
    const initialsWithLimit = (0, initials_1.default)(user?.fullName || '').slice(0, 2);
    const renderUserProfilePicture = (0, react_1.useCallback)(() => {
        if (!user) {
            return null;
        }
        if (lodash_1.default.isEmpty(user.avatarUrl)) {
            return (0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "userAvatar", children: initialsWithLimit });
        }
        return (0, jsx_runtime_1.jsx)(material_1.Avatar, { "ts-variant": "circularsidebar", alt: user.fullName, src: user.avatarUrl });
    }, [initialsWithLimit, user]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Paper, { "ts-variant": "sideMenuFooterPaper", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: { margin: '10px', cursor: 'pointer' }, onClick: openUserDetailsAside, children: renderUserProfilePicture() }), (0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", "ts-variant": "sideMenmuFooterDetailDiv", children: [user?.fullName && ((0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "imgSideSpan", title: user.fullName, children: user.fullName })), user?.companyName && ((0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "imgSideSub", title: user.companyName, children: user.companyName }))] }), (0, jsx_runtime_1.jsxs)(material_1.Typography, { component: "div", sx: { display: 'flex', marginLeft: 'auto', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(material_1.Link, { "data-testid": "user-settings-btn", "ts-variant": "sideMenuFooterLink", onClick: openUserDetailsAside, children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { style: {
                                marginTop: '15px',
                                marginLeft: '5px',
                                filter: 'invert(1)',
                            }, component: Settings_2.default })) : ((0, jsx_runtime_1.jsx)(Settings_1.default, { id: "settings-icon" })) }), (0, jsx_runtime_1.jsx)(material_1.Link, { style: {
                            color: 'white',
                        }, "data-testid": "sideMenu-logout-btn", "ts-variant": "sideMenuFooterLink", onClick: async (event) => {
                            event.preventDefault();
                            try {
                                await logout.mutateAsync();
                                const initialState = zustandStore_1.useZustand.getInitialState();
                                zustandStore_1.useZustand.setState(initialState);
                            }
                            catch (error) {
                                logger.error('Error in logging out', error);
                            }
                            finally {
                                globalThis.location.href = '/signin/login';
                            }
                        }, children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'Logout' : (0, jsx_runtime_1.jsx)(PowerSettingsNew_1.default, {}) })] })] }));
};
exports.default = SideMenuFooter;
